export async function prepareLocalDesktopLaunch() { return null; }
export async function releaseLocalDesktopLaunch() {}
export function startLocalDesktopWorker() { return () => {}; }
export async function configureLocalDesktop() { throw new Error('Computer access is available in the updated Mac app.'); }
